const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:8008';

function getToken() {
  return localStorage.getItem('honeydo_token');
}

async function request(path, { method = 'GET', body, isFormData = false } = {}) {
  const headers = {};
  const token = getToken();
  if (token) headers.Authorization = `Bearer ${token}`;
  if (!isFormData && body !== undefined) headers['Content-Type'] = 'application/json';

  const response = await fetch(`${API_BASE_URL}${path}`, {
    method,
    headers,
    body: isFormData ? body : body !== undefined ? JSON.stringify(body) : undefined,
  });

  if (!response.ok) {
    let message = `Request failed (${response.status})`;
    try {
      const data = await response.json();
      if (data.error) message = data.error;
    } catch {
      // response body wasn't JSON — keep the generic message
    }
    throw new Error(message);
  }

  const contentType = response.headers.get('content-type') || '';
  if (contentType.includes('application/json')) {
    return response.json();
  }
  return response;
}

export const api = {
  login: (email, password) => request('/auth/login', { method: 'POST', body: { email, password } }),

  listUsers: () => request('/admin/users'),
  createUser: (name, email, password, role) =>
    request('/admin/users', { method: 'POST', body: { name, email, password, role } }),
  setUserActive: (id, is_active) =>
    request(`/admin/users/${id}`, { method: 'PATCH', body: { is_active } }),

  listAssignableUsers: () => request('/users'),

  listTasks: (params) => {
    const qs = new URLSearchParams(params).toString();
    return request(`/tasks${qs ? `?${qs}` : ''}`);
  },
  getTask: (id) => request(`/tasks/${id}`),
  // Returns { tasks: [...] } — one row per (assignee x repeat occurrence).
  createTask: (formData) => request('/tasks', { method: 'POST', body: formData, isFormData: true }),
  completeTask: (id, formData) =>
    request(`/tasks/${id}/complete`, { method: 'PATCH', body: formData, isFormData: true }),
  // Admin only. Send just the fields that changed.
  updateTask: (id, updates) => request(`/tasks/${id}`, { method: 'PATCH', body: updates }),
  reopenTask: (id) => request(`/tasks/${id}/reopen`, { method: 'PATCH' }),
  archiveTask: (id) => request(`/tasks/${id}/archive`, { method: 'PATCH' }),
  unarchiveTask: (id) => request(`/tasks/${id}/unarchive`, { method: 'PATCH' }),
  taskPhotoUrl: (id) => `${API_BASE_URL}/tasks/${id}/photo`,
  taskCompletionPhotoUrl: (id) => `${API_BASE_URL}/tasks/${id}/completion-photo`,
  listSuggestions: (field) => request(`/tasks/suggestions?field=${field}`),

  listTemplates: () => request('/templates'),
  listAllTemplates: () => request('/templates?all=true'),
  createTemplate: (name, description, repeat_interval, repeat_count) =>
    request('/templates', {
      method: 'POST',
      body: { name, description, repeat_interval, repeat_count },
    }),
  updateTemplate: (id, updates) => request(`/templates/${id}`, { method: 'PATCH', body: updates }),

  registerDeviceToken: (fcm_token) =>
    request('/devices/token', { method: 'POST', body: { fcm_token } }),
};

export function saveToken(token) {
  localStorage.setItem('honeydo_token', token);
}

export function clearToken() {
  localStorage.removeItem('honeydo_token');
}

export function hasToken() {
  return !!getToken();
}

export { getToken, API_BASE_URL };
